<template>
  <svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M13.72 5.147L2.425 24a2.667 2.667 0 002.28 4h22.586a2.666 2.666 0 002.28-4L18.28 5.147a2.667 2.667 0 00-4.56 0v0zM16 12v5.333M16 22.667h.013" stroke="#fff" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/></svg>
</template>

<script>
export default {
  name: 'AlertIcon',
};
</script>
